<template>
  <div class="print-box">
    <Icon
      v-if="printStyle" class="close-modal-icon"
      type="md-close" @click="$emit('closeModal')"
    />
    <div ref="printDom" class="table-box">
      <div>
        <table class="subject-header-table subject-table print-table long-table">
          <thead>
            <tr>
              <th colspan="12">结算确认单</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tl" colspan="6">结算单号：{{ defaultData.code || "" }}
                <Tag
                  v-if="defaultData.deducted" color="error"
                  style="marginLeft:10px"
                >待抵扣</Tag>
              </td>
              <td class="tl" colspan="6">结算方案：{{ defaultData.settlementPlan ? defaultData.settlementPlan+'方案' :'' }}</td>
            </tr>
            <tr>
              <td class="tl" colspan="12">所属项目：{{ defaultData.projName || "" }}</td>
            </tr>
            <tr>
              <td colspan="6">案件信息</td>
              <td colspan="3">收入明细</td>
              <td colspan="2">乙方报酬</td>
              <td></td>
            </tr>
            <tr>
              <td class="subject-table-color">案件编号</td>
              <td class="subject-table-color">案号</td>
              <td class="subject-table-color">寄送诉讼材料日期</td>
              <td class="subject-table-color">立案日期</td>
              <td class="subject-table-color">结算方案</td>
              <td class="subject-table-color">结案方式</td>
              <td class="subject-table-color">诉讼退费</td>
              <td class="subject-table-color">收款人</td>
              <td class="subject-table-color">到账日期</td>
              <td class="subject-table-color">返回退费</td>
              <td class="subject-table-color">税点差扣费</td>
              <td class="subject-table-color">结算金额</td>
            </tr>
            <tr v-for="(item,index) in defaultData.settlementDetailList" :key="index">
              <td>{{ item.caseCode || "" }}</td>
              <td>{{ item.caseNo || "" }}</td>
              <td>{{ common.formatTime(item.sentTime,1) }}</td>
              <td>{{ common.formatTime(item.filingDate,1) }}</td>
              <td>{{ item.settlementPlan ? item.settlementPlan+'方案' :'' }}</td>
              <td>{{ item.closeTypeName || "" }}</td>
              <td>{{ common.formateNumber(item.refundFee || 0) }}</td>
              <td>{{ item.receiptName || "" }}</td>
              <td>{{ item.receiptTime || "" }}</td>
              <td>{{ common.formateNumber(item.returnRefundFee || 0) }}</td>
              <td>{{ common.formateNumber(item.taxPointFee || 0) }}</td>
              <td>{{ common.formateNumber(item.settleFee) }}</td>  <!-- 结算金额 -->
            </tr>
            <tr>
              <td class="tr" colspan="6">合计：</td>
              <td colspan="3">{{ common.formateNumber(incomeAmount) }}</td>
              <td colspan="2"></td>
              <td>{{ common.formateNumber(defaultData.settleFee) }}</td>
            </tr>
            <tr>
              <p>  结算备注：{{ defaultData.remark || "" }} </p>
              <p v-if="defaultData.adjustInfo&&defaultData.adjustInfo.remark">  调整说明：{{ defaultData.adjustInfo.remark || "" }}</p>
            </tr>
            <tr>
              <td class="tl" colspan="12">
                <p>乙方账户信息</p>
                <p>账户名称：{{ defaultData.bankUser }}</p>
                <p>银行帐号：{{ defaultData.cardNumber }}</p>
                <p>开户行：{{ defaultData.bankName }}</p>
              </td>
            </tr>
            <tr>
              <td class="tl mes-box" colspan="12">
                <p>甲方开票信息</p>
                <p>单位名称：{{ defaultData.invoice.companyName || "" }}</p>
                <p>开户银行：{{ defaultData.invoice.bankName || "" }}</p>
                <p>银行帐号：{{ defaultData.invoice.bankAccount || "" }}</p>
                <p>纳税人识别号：{{ defaultData.invoice.identificationNum || "" }}</p>
                <p>地址：{{ defaultData.invoice.address || "" }}</p>
                <p>电话：{{ defaultData.invoice.phone || "" }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="printStyle" class="tc btn-box">
        <Button type="primary" @click="printPage">打印</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['defaultData'],
  data () {
    return {
      printStyle: true
    }
  },
  computed: {
    incomeAmount() {
      let num = 0
      const arr = this.defaultData.settlementDetailList || []
      arr.forEach((item, index) => {
        num += (item.refundFee || 0)
      })
      return num
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    console.log('defaultData', this.defaultData)
  },
  mounted() {},
  updated() {},
  methods: {
    printPage() {
      this.printStyle = false
      this.$nextTick(() => {
        this.printStyle = true
        this.$print(this.$refs.printDom)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./../../tradingCenter/mailingList/print.scss";
.print-box{
    padding:10px 20px;
}
.mes-box{
    >p{
        margin-bottom: 5px;
        &:last-child{
            margin-bottom: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/settlementCenter/plugin/litigationSettlementPrint.vue